import { render, staticRenderFns } from "./CheckboxLoader.vue?vue&type=template&id=38b74695"
import script from "./CheckboxLoader.vue?vue&type=script&lang=js"
export * from "./CheckboxLoader.vue?vue&type=script&lang=js"
import style0 from "./CheckboxLoader.vue?vue&type=style&index=0&id=38b74695&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports